import { Component, Input } from '@angular/core';
import { FicheConseil, TransactionPersonnelleEnum } from '@lib/models/generated/graphql';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

@Component({
  selector: 'app-transaction-personelle',
  templateUrl: './transaction-personelle.component.html',
  styleUrls: ['./transaction-personelle.component.scss'],
})
export class TransactionPersonelleComponent {
  radioControl: FieldFormControl<TransactionPersonnelleEnum>;
  toggleControl: FieldFormControl<boolean, TransactionPersonnelleEnum>;
  transactionOption = TransactionPersonnelleEnum;

  @Input({ required: true })
  isWithCoInvestisseur: boolean;
  @Input({ required: true })
  currentFicheConseil: FicheConseil;

  /**
   *
   *  commented code is old design and logic but we should wait to get rid of it: there is disturbance in the force
   *
   */

  constructor(protected formConfigService: FormConfigService, protected ficheConseilService: FicheConseilService) {
    // this.radioControl = new FieldFormControl<TransactionPersonnelleEnum>({
    //   formConfigService: this.formConfigService,
    //   ficheConseilService: this.ficheConseilService,
    //   dataKey: 'transactionPersonnelle',
    //   defaultValue: TransactionPersonnelleEnum.Non,
    // });

    this.toggleControl = new FieldFormControl<boolean, TransactionPersonnelleEnum>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'transactionPersonnelle',
      ficheDataToFieldDataWrapper: (data: TransactionPersonnelleEnum) =>
        data === TransactionPersonnelleEnum.AutoSouscription,
      fieldDataToFicheDataWrapper: (fieldData: boolean) =>
        fieldData ? TransactionPersonnelleEnum.AutoSouscription : TransactionPersonnelleEnum.Non,
      defaultValue: false,
    });
  }
  ngOnInit() {
    this.toggleControl.setValue(
      this.currentFicheConseil?.transactionPersonnelle === TransactionPersonnelleEnum.AutoSouscription
    );
    //this.radioControl.setValue(this.currentFicheConseil?.transactionPersonnelle ?? TransactionPersonnelleEnum.Non);
  }
}
